import { styled } from 'linaria/react';
import { css } from 'linaria';
import { bestPriceNameplateContainer, styles } from 'common/components/product-price-view/styles';

export const VariantPreviewWrapper = styled.div`
  border-radius: var(--rounding-l);
  background-color: var(--background-secondary);
  display: grid;
  padding: var(--space-200);
  grid-gap: var(--space-200);
  grid-template-columns: 1fr auto;
  img {
    width: 108px;
    height: 108px;
    mix-blend-mode: multiply;
  }
`;

export const secondPrice = css`
  margin-top: var(--space-25);
  font-size: 12px;
  line-height: 16px;
`;

export const picture = css`
  height: auto;

  picture {
    padding: 0;
  }
`;

export const oldNewPrice = css`
  margin-top: var(--space-100) !important;
  margin-bottom: 0 !important;

  .${styles.signaturePrimary}, .${styles.newCurrencyWrap} {
    font-size: 14px;
  }

  .${styles.newPriceMainWrap} {
    font-size: 22px;
  }

  .${bestPriceNameplateContainer} {
    margin-bottom: var(--space-50) !important;
  }
`;
